import Loader from '@anm/components/Loader';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { CHART_BAR_HEIGHT } from '..';
import { projectSelectors } from '../../../../../../store/modules/project';
import { ContentDataWrapper, InfoMessage } from '../Wrapper';
import { useNoDataMessage } from '../hooks';
import { CartInfoContentProps } from '../types';

import { ChartBar, MockChartWrapper } from './Wrapper';

const INFO_MESSAGE_MAX_WIDTH = 451;
const mockChartData = [30, 70, 50, 40, 90, 130, 51];

const MockChart: FC = () => (
  <MockChartWrapper>
    {mockChartData.map(height => (
      <ChartBar key={height} {...{ height }} />
    ))}
  </MockChartWrapper>
);

const ChartInfoContent: FC<CartInfoContentProps> = ({
  maxWidth,
  isPending,
  ...restProps
}) => {
  const [canShowMessage, renderMessage] = useNoDataMessage(restProps);

  const isProjectEverRender = useSelector(
    projectSelectors.selectCurrentProjectEverRendered
  );

  const canShowInfoMessage = canShowMessage && isProjectEverRender;

  return (
    <ContentDataWrapper isBordered height={CHART_BAR_HEIGHT} {...{ maxWidth }}>
      {isPending ? (
        <Loader size="medium" color="blue" />
      ) : canShowInfoMessage ? (
        <InfoMessage maxWidth={INFO_MESSAGE_MAX_WIDTH}>
          {renderMessage()}
        </InfoMessage>
      ) : !isProjectEverRender ? (
        <MockChart />
      ) : null}
    </ContentDataWrapper>
  );
};

export default ChartInfoContent;
